import React from 'react';
import { Button, ListGroup } from 'react-bootstrap';
import { FaTrash, FaClipboardList, FaFilePdf, FaChevronRight } from 'react-icons/fa';
import { isGeneralUnitId } from '../../platform/constants';

function getAttachmentCount(article) {
  if (Array.isArray(article.attachments) && article.attachments.length > 0) {
    return article.attachments.length;
  }
  return article.fileUrl ? 1 : 0;
}

function ArticleCard({
  article,
  tenantId,
  isUnread,
  canDelete,
  reserveDeleteAction = false,
  variant = 'default',
  compact = false,
  onSelectArticle,
  onDelete,
}) {
  const attachmentCount = getAttachmentCount(article);
  const showUnit = !compact && article.unit && !isGeneralUnitId(article.unit, tenantId);

  const showActionsColumn = reserveDeleteAction || canDelete;

  const className = [
    'article-list-item',
    'platform-content-list-item',
    variant === 'featured' && 'article-list-item--featured',
    variant === 'archive' && 'article-list-item--archive',
    compact && 'article-list-item--compact',
    isUnread && 'article-list-item--unread platform-content-list-item--unread',
  ].filter(Boolean).join(' ');

  const deleteButton = canDelete ? (
    <Button
      variant="outline-danger"
      size="sm"
      className="article-list-item-delete"
      onClick={(event) => {
        event.stopPropagation();
        onDelete(article);
      }}
      aria-label={`Izbriši obrazec ${article.title}`}
    >
      <FaTrash />
      {!compact && <> Izbriši</>}
    </Button>
  ) : null;

  return (
    <ListGroup.Item
      className={className}
      onClick={() => onSelectArticle(article)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onSelectArticle(article);
        }
      }}
      tabIndex={0}
      aria-label={article.title}
    >
      <div
        className={[
          'platform-content-list-item-main',
          showActionsColumn && !compact && 'platform-content-list-item-main--has-actions',
        ].filter(Boolean).join(' ')}
      >
        <div className="platform-content-list-item-content article-list-item-content">
          <div className="platform-content-list-item-thumb platform-content-list-item-thumb--icon article-list-item-thumb">
            {isUnread && (
              <span className="platform-content-list-item-unread-badge">
                <span
                  className="platform-unread-dot"
                  title="Neprebrano"
                  aria-label="Neprebrano"
                />
              </span>
            )}
            {article.thumbnailUrl ? (
              <img src={article.thumbnailUrl} alt="" loading="lazy" />
            ) : (
              <div className="platform-content-list-item-thumb-placeholder" aria-hidden="true">
                <FaClipboardList />
              </div>
            )}
          </div>

          <div className="article-list-item-body platform-content-list-item-body">
            <div className="article-list-item-title platform-content-list-item-title">
              {article.title}
            </div>
            {article.description && !compact && (
              <div className="article-list-item-description platform-content-list-item-excerpt">
                {article.description}
              </div>
            )}
            {(attachmentCount > 0 || (showUnit && article.unitName)) && (
              <div className="article-list-item-meta platform-content-list-item-footer">
                {attachmentCount > 0 && (
                  <span className="article-list-item-meta-item">
                    <FaFilePdf aria-hidden="true" />
                    {attachmentCount === 1 ? 'PDF' : `${attachmentCount} PDF`}
                  </span>
                )}
                {showUnit && article.unitName && (
                  <>
                    {attachmentCount > 0 && (
                      <span className="article-list-item-meta-sep" aria-hidden="true">·</span>
                    )}
                    <span>{article.unitName}</span>
                  </>
                )}
              </div>
            )}
          </div>

          <div className="article-list-item-trailing">
            {compact && showActionsColumn && (
              <span className="article-list-item-delete-slot">
                {deleteButton}
              </span>
            )}
            <FaChevronRight
              className="article-list-item-chevron platform-content-list-item-chevron"
              aria-hidden="true"
            />
          </div>
        </div>

        {!compact && showActionsColumn && (
          <div className="article-list-item-aside platform-content-list-item-aside">
            <div className="platform-content-list-item-aside-inner">
              {canDelete ? (
                <div className="article-list-item-actions platform-content-list-item-actions">
                  {deleteButton}
                </div>
              ) : null}
            </div>
          </div>
        )}
      </div>
    </ListGroup.Item>
  );
}

export default ArticleCard;
